import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import VideoTitle from "./VideoTitle";
import VideoBackground from "./VideoBackground";
import MovieInfoCard from "./MovieInfoCard";

const MainContainer = () => {
  const [showInfoCard, setShowInfoCard] = useState(false);
  const navigate = useNavigate();
  const movies = useSelector((store) => store.movies?.nowPlayingMovies);
  
  if (!movies) return;
  const mainMovie = movies[0];
  const { original_title, overview, id } = mainMovie;

  const handlePlayClick = () => {
    navigate(`/movie/${id}`);
  };

  const handleMoreInfoClick = () => {
    setShowInfoCard(true);
  };

  const handleCloseInfoCard = () => {
    setShowInfoCard(false);
  };

  return (
    <div className="md:pt-0 pt-20">
      <VideoTitle
        title={original_title}
        overview={overview}
        onPlayClick={handlePlayClick}
        onMoreInfoClick={handleMoreInfoClick}
      />
      <VideoBackground movieId={id} />
      {showInfoCard && (
        <MovieInfoCard movieId={id} onClose={handleCloseInfoCard} />
      )}
    </div>
  );
};

export default MainContainer;
